import axios from "axios";
import { setupInterceptorsTo } from "./Interceptors";

setupInterceptorsTo(axios);
